import { Page } from "../enums/Page";
import { css, html } from "../helpers/webComponents";
import { BlockShiftPuzzleService } from "../services/BlockShiftPuzzleService";
import { GameEventService } from "../services/GameEventService";

const styles: string = css`
    .container {
        display: flex;
        justify-content: center;
        gap: 1rem;
        flex-direction: column;
    }

    #reset {
        font-family: "OneSize";
        font-size: 1.5rem;
        padding: 1rem 2rem;
        background: #AAB7B7;
        color: #535959;
        cursor: pointer;
    }

    #reset:hover {
        background: #c14747;
        color: white;
    }

    .puzzle {
        width: 384px;
        height: 384px;
        padding: 32px;
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url("/assets/img/puzzles/block_shift_puzzle_background.png");
    }
`;

export class BlockShiftPuzzleComponent extends HTMLElement {
    private readonly _blockShiftPuzzleService: BlockShiftPuzzleService = new BlockShiftPuzzleService();
    private readonly _gameEventService: GameEventService = new GameEventService();

    public connectedCallback(): void {
        // Attach a shadow root for scoped styling
        this.attachShadow({ mode: "open" });
        // Set the initial state of the puzzle
        void this.render();
    }

    private async render(): Promise<void> {
        // Don't render if there isn't a shadow root
        if (!this.shadowRoot) return;
        const element: HTMLElement = html`
            <div class="container">
                <div class="puzzle">
                    <canvas width="384" height="384"></canvas>
                </div>
                <button id="reset">Reset</button>
            </div>
            
        `;
        const canvas: HTMLCanvasElement = element.querySelector("canvas")!;
        const reset: HTMLButtonElement = element.querySelector("#reset")!;

        reset.addEventListener("click", async () => await this._blockShiftPuzzleService.resetPuzzle(canvas));
        this.shadowRoot.replaceChildren(html`<style>${styles}</style>`, element);
        await this._blockShiftPuzzleService.refreshPuzzle(canvas);
        canvas.addEventListener("click", async (event: MouseEvent) => {
            const solved: boolean = await this._blockShiftPuzzleService.moveBlock(canvas, event.offsetX, event.offsetY);
            if (solved) this._gameEventService.switchPage(Page.Canvas);
        });
    }
}
